import { CheckCircle2 } from "lucide-react";
import { services } from "../data/services";
import { citiesByProvince } from "../data/cities";
import { getHead } from "../seo/routes";
import { serviceCityIntro, serviceCityLocal, cityCta, serviceCityFaqs } from "../seo/content";
import { Seo } from "../components/Seo";
import { PageHero, Prose, FAQBlock, CTABand, Breadcrumbs, LinkGrid, SectionHead } from "../components/Blocks";

export default function ServiceCityPage({ service, city, province }) {
  const path = `/${service.slug}-in-${city.slug}`;
  const faqs = serviceCityFaqs(service, city, province);
  const head = getHead(path, { faqs });
  const otherServices = services.filter((s) => s.slug !== service.slug);
  const nearbyCities = citiesByProvince(province.slug).filter((c) => c.slug !== city.slug).slice(0, 12);
  return (
    <>
      <Seo title={head.title} description={head.description} path={path} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: service.name, to: `/services/${service.slug}` }, { label: `${city.name}, ${province.abbr}` }]} />
      <PageHero
        overline={`${service.name} · ${city.name}, ${province.abbr}`}
        title={`${service.name} in ${city.name}`}
        lead={service.short}
        image={service.image}
      />
      <Prose paragraphs={[serviceCityIntro(service, city, province), serviceCityLocal(service, city, province), cityCta(city)]} />
      <section className="bg-[#131620] border-y border-white/10" data-testid="servicecity-deliverables">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <SectionHead overline="Scope of Work" title={`${service.name} in ${city.name} — What's Included`} />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {service.deliverables.map((d) => (
              <div key={d} className="flex items-start gap-3 border border-white/10 bg-[#0D0E12] p-4 rounded-sm">
                <CheckCircle2 className="h-5 w-5 text-[#FF5500] shrink-0 mt-0.5" />
                <span className="text-sm text-gray-300 leading-relaxed">{d}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FAQBlock faqs={faqs} heading={`${service.name} in ${city.name} — FAQs`} />
      <LinkGrid
        overline="More in This City"
        title={`Other Security Services in ${city.name}`}
        cols="grid-cols-2 sm:grid-cols-3 lg:grid-cols-5"
        items={otherServices.map((s) => ({ to: `/${s.slug}-in-${city.slug}`, label: s.name, testid: `other-service-${s.slug}` }))}
      />
      {nearbyCities.length > 0 && (
        <LinkGrid
          overline="Nearby Coverage"
          title={`${service.name} in Other ${province.name} Cities`}
          items={nearbyCities.map((c) => ({ to: `/${service.slug}-in-${c.slug}`, label: c.name, testid: `nearby-${c.slug}` }))}
        />
      )}
      <CTABand title={`Book ${service.name} in ${city.name}`} sub="Reach our 24/7 dispatch by phone or email. A coordinator will scope your site and prepare written post orders before the first shift." />
    </>
  );
}
